<div class="tree-container flex flex-row full-grow-no-shrink-no-basis">
  <mat-tree class="custom-tree" [dataSource]="dataSource" [treeControl]="treeControl">
    <mat-tree-node class="custom-tree-node" style="position:relative" [id]="node.id"
                   [ngClass]="{'control-show': node.item.id === selectedNodeId,'excluded-item':node.item.isHidden==true || node.item.isParentHidden==true}"
                   attr.question-id="{{node.item.questionId}}" (click)="onSelectedNode(node); $event.stopPropagation();"
                   *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
      <div class="node-wrapper w-p-100 flex flex-col justify-start items-center"
           [ngClass]="{'state-highlight': node.item.id === selectedNodeId}">
        <div class="w-p-100 flex flex-row justify-start items-center">
          <div class="left-section flex flex-row justify-start items-center full-grow-no-shrink-no-basis">
            <div class="button-container">
              <button *ngIf="node.item?.children.length>0" mat-icon-button matTreeNodeToggle
                      [attr.aria-label]="'toggle ' + node.item?.title">
                <mat-icon class="mat-icon-rtl-mirror">
                  {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                </mat-icon>
              </button>
            </div>
            <div class="content-container flex flex-row justify-start items-center full-grow-no-shrink-no-basis">
              <div *ngIf="node.item?.conditionDisplayText && node.item?.conditionDisplayText.length>0"
                   class="tagg flex flex-row justify-start items-center">
                <div class="custom-icon">
                  <span></span>
                  <span></span>
                </div>
                {{node.item?.conditionDisplayText}}</div>
              <div class="content flex flex-row justify-start items-start full-grow-no-shrink-no-basis">
                <div>{{node.item?.questionId}}.</div>
                <div class="m-l-5">{{node.item?.title}}.</div>
                <div *ngIf="node.item?.isMandatory">&nbsp;*</div>
                <div class="description flex-1-0-auto"
                     title="{{node.item?.instruction ? node.item?.instruction : ''}}"> {{node.item?.instruction ? node.item?.instruction : ''}}</div>


              </div>
            </div>
          </div>
          <div class="right-section m-r-14">
            <button mat-icon-button [matMenuTriggerFor]="actionMenu"
                    class="no-animation-btn icon-dropdown-button">
              <mat-icon class="s-20">more_horiz</mat-icon>
            </button>
            <mat-menu #actionMenu="matMenu" class="action-button-dropdown-container" [overlapTrigger]="false">
              <button
                *ngIf="!node.item.isHidden && fieldDefinitions[node.item.fieldKey]&& fieldDefinitions[node.item.fieldKey].isReadOnly==false"
                mat-menu-item class="" (click)="onEdit(node)">
                <span>Edit</span>
              </button>
              <button
                *ngIf="!node.item.isHidden && hasTagsMapping[node.item.fieldKey] && hasTagsMapping[node.item.fieldKey].hasApplyHallmarkTags"
                mat-menu-item class="" (click)="openApplyHallmarkTagsPopUp(node)">
                <span>Apply Hallmark Tags</span>
              </button>
              <!--<button *ngIf="!node.item.isHidden && hasTagsMapping[node.item.fieldKey] && hasTagsMapping[node.item.fieldKey].hasFieldDetais" mat-menu-item class=""  (click)="openDetailsPopUp(node)">
                <span>View Details</span>
              </button>-->
              <button
                *ngIf="!node.item.isHidden && hasTagsMapping[node.item.fieldKey] && hasTagsMapping[node.item.fieldKey].hasHallmarkShowTags"
                mat-menu-item class="" (click)="openHallmarkShowTagsPopUp(node)">
                <span>Show Tags</span>
              </button>
              <button *ngIf="!node.item.isHidden" mat-menu-item class="" (click)="openConversationForThisField(node)">
                <span>Open Conversation</span>
              </button>
              <button *ngIf="!node.item.isHidden" mat-menu-item class="" (click)="openDetailsAndInstructions(node)">
                <span>Details & Instructions</span>
              </button>
            </mat-menu>
          </div>
          <!--<div class="tags left">
            <div
              *ngIf="!node.item.isHidden && hasTagsMapping[node.item.fieldKey] && hasTagsMapping[node.item.fieldKey].hasFieldDetais"
              class="" (click)="openDetailsPopUp(node)" class="tag pointer">
              View Details
            </div>
          </div>-->
          <div class="tags right">


            <div
              *ngIf="!node.item.isHidden && hasTagsMapping[node.item.fieldKey] && hasTagsMapping[node.item.fieldKey].hasApplyHallmarkTags"
              class="" (click)="openApplyHallmarkTagsPopUp(node)" class="tag pointer">
              Apply Hallmark Tags
            </div>

            <div
              *ngIf="!node.item.isHidden && hasTagsMapping[node.item.fieldKey] && hasTagsMapping[node.item.fieldKey].hasHallmarkShowTags"
              class="" (click)="openHallmarkShowTagsPopUp(node)" class="tag pointer">
              Show Tags
            </div>

          </div>
        </div>
        <div *ngIf="rowItem && rowItem.cells" mat-menu-item class="" (click)="onEdit(node)" class="fake-input">
          <div class="input"
               matTooltip="{{rowItem.cells[node.item.fieldKey] ? rowItem.cells[node.item.fieldKey].displayText : ''}}"> {{rowItem.cells[node.item.fieldKey] ? rowItem.cells[node.item.fieldKey].displayText : ''}}</div>
          <i class="fas fa-caret-down"></i>
          <!--          <div *ngIf="rowItem && rowItem.cells" class="grid-cell-ellipsis"-->
          <!--               matTooltip="{{rowItem.cells[node.item.fieldKey] ? (rowItem.cells[this.node.item.fieldKey].value?.toolTip ? rowItem.cells[this.node.item.fieldKey].value?.toolTip : rowItem.cells[node.item.fieldKey].displayText) : ''}}">-->
          <!--            {{rowItem.cells[node.item.fieldKey] ? rowItem.cells[node.item.fieldKey].displayText : ''}}-->
          <!--          </div>-->
        </div>

      </div>
    </mat-tree-node>

    <mat-tree-node class="custom-tree-node" [id]="node.id"
                   [ngClass]="{'control-show': node.item.id === selectedNodeId,'excluded-item':node.item.isHidden==true || node.item.isParentHidden==true}"
                   attr.question-id="{{node.item.questionId}}" (click)="onSelectedNode(node); $event.stopPropagation();"
                   *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
      <div class="node-wrapper w-p-100 flex flex-col justify-start items-center"
           [ngClass]="{'state-highlight': node.item.id === selectedNodeId}">
        <div class="w-p-100 flex flex-row justify-start items-center">
          <div class="left-section flex flex-row justify-start items-center full-grow-no-shrink-no-basis">
            <div class="button-container">
              <button *ngIf="node.item?.children.length>0" mat-icon-button matTreeNodeToggle
                      [attr.aria-label]="'toggle ' + node.item?.title">
                <mat-icon class="mat-icon-rtl-mirror">
                  {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                </mat-icon>
              </button>
            </div>
            <div class="content-container flex flex-row justify-start items-center full-grow-no-shrink-no-basis">
              <div *ngIf="node.item?.conditionDisplayText && node.item?.conditionDisplayText.length>0"
                   class="tagg flex flex-row justify-start items-center">
                <div class="custom-icon flex flex-col">
                  <span></span>
                  <span></span>
                </div>
                {{node.item?.conditionDisplayText}}</div>
              <div class="content flex flex-row justify-start items-start full-grow-no-shrink-no-basis">
                <div>{{node.item?.questionId}}.</div>
                <div class="m-l-5">{{node.item?.title}}.</div>
                <div *ngIf="node.item?.isMandatory">&nbsp;*</div>
                <div class="description flex-1-0-auto"
                     title="{{node.item?.instruction ? node.item?.instruction : ''}}"> {{node.item?.instruction ? node.item?.instruction : ''}}</div>


              </div>
            </div>
          </div>
          <div class="right-section m-r-14">
            <button mat-icon-button [matMenuTriggerFor]="actionMenu"
                    class="no-animation-btn icon-dropdown-button" (click)="closeRightSidebar()">
              <mat-icon class="s-20">more_horiz</mat-icon>
            </button>
            <mat-menu #actionMenu="matMenu" class="action-button-dropdown-container" [overlapTrigger]="false">
              <button
                *ngIf="!node.item.isHidden && fieldDefinitions[node.item.fieldKey]&& fieldDefinitions[node.item.fieldKey].isReadOnly==false"
                mat-menu-item class="" (click)="onEdit(node)">
                <span>Edit</span>
              </button>
              <button
                *ngIf="!node.item.isHidden && hasTagsMapping[node.item.fieldKey] && hasTagsMapping[node.item.fieldKey].hasApplyHallmarkTags"
                mat-menu-item class="" (click)="openApplyHallmarkTagsPopUp(node)">
                <span>Apply Hallmark Tags</span>
              </button>
              <!--<button *ngIf="!node.item.isHidden && hasTagsMapping[node.item.fieldKey] && hasTagsMapping[node.item.fieldKey].hasFieldDetais" mat-menu-item class=""  (click)="openDetailsPopUp(node)">
                <span>View Details</span>
              </button>-->
              <button
                *ngIf="!node.item.isHidden && hasTagsMapping[node.item.fieldKey] && hasTagsMapping[node.item.fieldKey].hasHallmarkShowTags"
                mat-menu-item class="" (click)="openHallmarkShowTagsPopUp(node)">
                <span>Show Tags</span>
              </button>
              <button *ngIf="!node.item.isHidden" mat-menu-item class="" (click)="openConversationForThisField(node)">
                <span>Open Conversation</span>
              </button>
              <button *ngIf="!node.item.isHidden" mat-menu-item class="" (click)="openDetailsAndInstructions(node)">
                <span>Details & Instructions</span>
              </button>
            </mat-menu>
          </div>
          <!--<div class="tags left">
            <div
              *ngIf="!node.item.isHidden && hasTagsMapping[node.item.fieldKey] && hasTagsMapping[node.item.fieldKey].hasFieldDetais"
              class="" (click)="openDetailsPopUp(node)" class="tag pointer">
              View Details
            </div>
          </div>-->
          <div class="tags right">
            <div
              *ngIf="!node.item.isHidden && hasTagsMapping[node.item.fieldKey] && hasTagsMapping[node.item.fieldKey].hasApplyHallmarkTags"
              class="" (click)="openApplyHallmarkTagsPopUp(node)" class="tag pointer">
              Apply Hallmark Tags
            </div>

            <div
              *ngIf="!node.item.isHidden && hasTagsMapping[node.item.fieldKey] && hasTagsMapping[node.item.fieldKey].hasHallmarkShowTags"
              class="" (click)="openHallmarkShowTagsPopUp(node)" class="tag pointer">
              Show Tags
            </div>
          </div>
        </div>
        <div *ngIf="rowItem && rowItem.cells" (click)="onEdit(node)" class="fake-input">
          <div class="input"
               matTooltip="{{rowItem.cells[node.item.fieldKey] ? rowItem.cells[node.item.fieldKey].displayText : ''}}"> {{rowItem.cells[node.item.fieldKey] ? rowItem.cells[node.item.fieldKey].displayText : ''}}</div>
          <i class="fas fa-caret-down"></i>
          <!--          <div *ngIf="rowItem && rowItem.cells" class="grid-cell-ellipsis"-->
          <!--               matTooltip="{{rowItem.cells[node.item.fieldKey] ? (rowItem.cells[this.node.item.fieldKey].value?.toolTip ? rowItem.cells[this.node.item.fieldKey].value?.toolTip : rowItem.cells[node.item.fieldKey].displayText) : ''}}">-->
          <!--            {{rowItem.cells[node.item.fieldKey] ? rowItem.cells[node.item.fieldKey].displayText : ''}}-->
          <!--          </div>-->
        </div>

      </div>

    </mat-tree-node>
  </mat-tree>
</div>







